import { atsApiQuery } from '..';

export const customFieldsSettingsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllCustomFields: builder.query({
        providesTags: ['GetAllCustomFields'],
        transformResponse: (response) => response?.data,
        query: ({ apiType }) => {
          return {
            method: 'get',
            url: `ats_custom_fields?subject_type=${apiType}`,
          };
        },
        staleTime: 0,
      }),

      getCustomFields: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          return {
            params,
            method: 'get',
            url: `ats_custom_fields/form_fields`,
          };
        },
      }),

      createCustomField: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.ats_custom_field?.id) {
            return [{ type: 'GetAllCustomFields' }];
          }
          return [];
        },
      }),

      updateCustomField: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, fieldId }) => {
          return {
            method: 'put',
            url: `/ats_custom_fields/${fieldId}`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.ats_custom_field?.id) {
            return [{ type: 'GetAllCustomFields' }];
          }
          return [];
        },
      }),

      updateCustomFields: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ apiType, payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields/update_form_fields?subject_type=${apiType}`,
            data: { ...payload },
          };
        },
        invalidatesTags: ({ error = [] }) => {
          if (error?.length === 0) {
            return [{ type: 'GetAllCustomFields' }];
          }
          return [];
        },
      }),

      validateCustomFields: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ apiType, payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields/validate_offer_form_fields?subject_type=${apiType}`,
            data: { ...payload },
          };
        },
      }),

      deleteCustomField: builder.mutation({
        transformResponse: (response) => response,
        query: ({ fieldId }) => {
          return {
            method: 'delete',
            url: `/ats_custom_fields/${fieldId}`,
          };
        },
        invalidatesTags: ({ error = [] }) => {
          if (error?.length === 0) {
            return [{ type: 'GetAllCustomFields' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useCreateCustomFieldMutation,
  useDeleteCustomFieldMutation,
  useLazyGetAllCustomFieldsQuery,
  useUpdateCustomFieldMutation,
  useGetCustomFieldsQuery,
  useLazyGetCustomFieldsQuery,
  useValidateCustomFieldsMutation,
  useUpdateCustomFieldsMutation,
} = customFieldsSettingsApi;
